module.exports = __webpack_public_path__ + "img/ryylogo.77d69497.png";